import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import { AuthStore } from './store/store.auth';
import { UserWhitelistEnums } from './enums/UserWhitelistEnums';
import { AuthentificationService } from '@/services';

Vue.config.productionTip = false;

function handleOAuthCallBackUrl() {
    const isOauthCallback = window.location.href.includes('/*/login');
    const hasIdToken = window.location.href.includes('id_token=');
    if (isOauthCallback && hasIdToken) {

        const hashString = window.location.hash;
        const keyToFind = 'state=';
        const startIndex = hashString.indexOf(keyToFind) + keyToFind.length;

        const idValue = hashString.substring(startIndex);

        const targetHashRoute = '/login/state';

        const newUrl = `${window.location.origin}/#${targetHashRoute}=${idValue}`;

        window.location.replace(newUrl);
        return true;
    }
    return false;
}


if(!handleOAuthCallBackUrl()) {
new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
}).$mount('#app');
}

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    if (requiresAuth) {
        if (AuthStore.isLoggedIn === true
            && AuthStore.isWhitelisted === UserWhitelistEnums.WHITE) {
            next();
        } else if (AuthStore.isLoggedIn !== true && to.name === 'open') {
            AuthentificationService.SignInRedirect();
        } else {
            next('/noaccess');
        }
    } else {
        next();
    }
});
